import {
  styled,
  Typography,
  type CSSObject,
  GridLegacy as Grid,
  type GridProps,
} from '@mui/material';
import { Button, Section } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledButton = styled(Button)(({ theme }) => ({
  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.purpleColors?.PLUS_2}, 0px 0px 6px 4px ${theme.palette.purpleColors?.PLUS_2} inset !important`,
  },
}));
export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));

export const StyledFirstTitle = styled('div')(({ theme: { breakpoints } }) => ({
  fontWeight: '400',
  width: '100%',
  fontSize: '1.6vw',
  lineHeight: '100%',
  letterSpacing: '-0.02em',
  paddingBottom: '0.2rem',
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [breakpoints.down('sm')]: {
    fontSize: '7vw',
    textAlign: 'center',
  },
}));

export const StyledSectionTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: '100%',
  letterSpacing: '-0.02em',
  paddingBottom: theme.spacing(5),
  display: 'flex',
  justifyContent: 'left',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    justifyContent: 'center',
  },
}));
export const Expander = styled('div')<{ expanded: boolean; items: string }>`
  display: grid;
  grid-template-rows: ${({ expanded, items }) => (expanded ? '1fr' : items)};
  overflow: hidden;
  transition: grid-template-rows 1s;
`;

export const ExpanderContent = styled('div')<{ expanded: boolean }>`
  min-height: 0;
  visibility: 'visible';
  transition: visibility 1s;
`;

export const StyledRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  paddingBottom: theme.spacing(5),
}));

export const Item = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(5),
}));

export const StyledGrid = styled(Grid)<GridProps>(({}) => ({
  width: '100%',
  textAlign: 'center',
  paddingTop: '2rem',
}));
